import React, { Fragment, useEffect, useState } from 'react'
import styles from '../../styles/modules/components/whitepaper.module.scss'
import Checkbox from '../common/ui-components/input/Checkbox'
import UIDropdown from '../common/ui-components/input/UIDropdown/UIDropdown'
import parse from 'html-react-parser'
import { GetWhitePaperData } from '../../api/whitepaper/index'
import { validateInput } from '../../utils'

export default function Canvas() {

    const [data,setdata] = useState({
        category:[],
        years : [],
        data : [{
            title:"",
            data:"",
        }]
    })
    const [cat,setCat] = useState<any>([])
    const [year,setyear] = useState<any>([])
    const [sorting, setSort] = useState<any>({
        "key":1,
        "value":"desc",
        "text":"Publish Date(New-Old)"
    })
    const [search, setSearch] = useState<string>("")
    const [error,setError] = useState<boolean>(false)
    useEffect(()=>{
        getSearchResult()
    },[])

    const getSearchResult = async () => {
        const response = await GetWhitePaperData({sort:sorting["value"]})
        
        if(response)
        {
            if(response.data)
            {
                if(response.data.status){
                    setdata(response.data);
                    for(var i=0; i<response.data.category.length;i++)
                    setCat(arr => [...arr,false])
                    for(var i=0; i<response.data.years.length;i++)
                    setyear(arr => [...arr,false])
                    setError(false)
                }
                else{
                    setError(true)
                }
            }
        }
    }

    const getFilteredResult = (newSort="") => {
        let a = '';
        let b = '';
        for(let i=0;i<cat.length;i++)
        {
            if(cat[i])
            {
                a += data.category[i] + ',';
            }
        }
        a = a.slice(0,-1)
        for(let i=0;i<year.length;i++)
        {
            if(year[i])
            {
                b += data.years[i] + ',';
            }
        }
        b = b.slice(0,-1)
        GetWhitePaperData({cat:a,year:b,sort:newSort.length!=0 ? newSort : sorting["value"]})
        .then((response)=>{
            if(response)
            {
                if(response.data)
                {
                    if(response.data.status)
                    { 
                        setdata(response.data);
                        setError(false)
                    }
                    else
                    {
                        setError(true)
                    }
                }
            }
        })  
    }

    const sort:any[] = [
        {
            "key":1,
            "value":"desc",
            "text":"Publish Date(New-Old)"
        },
        {
            "key":2,
            "value":"asec",
            "text":"Publish Date(Old-New)"
        }
    ]

    const handleChange1= (id) => {
        let a = cat
        a[id] = !a[id]
        setSearch("")
        setCat(a)
        getFilteredResult()
    }
    const handleChange2= (id) => {
        let a = year
        a[id] = !a[id]
        setSearch("")
        setyear(a)
        getFilteredResult()

    }

    const handleSort = (e) => {
        setSort({key:e["key"],value:e["value"],text:e["text"]})
        getFilteredResult(e["value"])
        return false
    }

    const handleSearch = (e) => {
        setSearch(e.target.value)
    }

    const handleEnter = (e) => {
        var a;
        if(e.key){
          a = e.key
        }
        else
        {
          a = e.which || e.keyCode
        }
        if(a==="Enter"||a===13)
        {
            let a = cat
            let b = year
            for(let i=0;i<cat.length;i++)
            {
                a[i] = false
            }
            for(let j=0;j<year.length;j++)
            {
                b[j]=false;
            }
            setCat(a)
            setyear(b)
            GetWhitePaperData({sort:sorting["value"],search:search})
            .then((response)=>{
                if(response)
                {
                    if(response.data){
                    if(response.data.status)
                    {
                        setdata(response.data);
                        setError(false)
                    }
                    else{
                        setError(true)
                    }
                    }
                    
                }
            })

        }
      }

    return(
        <div className="container">
            <div className="row">
                <div className={`col-lg-3 col-12 col-md-12 ${styles.div__parentfilter}`}>
                <div className={`${styles.div__filter}`}>
                    <h6 className={`${styles.div__filtername}`}>Product Category </h6>
                    {
                        data.category && data.category.map((value,index)=>{
                            return <div className={`${styles.div__filterchoice}`}><Checkbox onChange={()=>{handleChange1(index)}}/><p>{value}</p></div>

                        })
                    }   
                </div>
                <div className={`${styles.div__filter}`}>
                    <h6 className={`${styles.div__filtername}`}>Year </h6>
                    {
                        data.years && data.years.map((value,index)=>{
                            return <div className={`${styles.div__filterchoice}`}><Checkbox onChange={()=>{handleChange2(index)}} /><p>{value}</p></div>

                        })
                    }   
                </div>
                </div>
                <div className="col-lg-9 col-12 col-md-12">
                    <div className={`${styles.div__searchbox}`}>
                        <input type="textbox" placeholder="Search analyst reports" value={search} onChange={(e: any) => handleSearch(validateInput(e))} onKeyPress={(e:any)=> handleEnter(e)}/>
                    </div>
                    <div className={`${styles.div__sortby}`}>
                        <p>Sort By: </p>
                        <div className={`${styles.div__sortdrop}`}>
                        <UIDropdown className={`${styles.div__sortdivdrop}`} onChange={(e: React.ChangeEvent<{}>) => handleSort(e)} placeholder="Publish Date(New-Old)" options={sort} selected_option={{text:sorting["text"],value:sorting["value"],key:sorting["key"]}} />
                        </div>
                    </div>
                    <div className={`${styles.div__content} whitepaper-content`}>
                        {
                            ( error || data.data.length==0 ) ?
                            <h3>No data found</h3>
                            :
                            data['data'].map((val,index)=>{
                                return ( <Fragment key={index}><h4>{val.title}</h4> {parse(val['data'])}</Fragment>
                                )
                            })
                                
                        }
                       
                    </div>
                </div>
            </div>
        </div>
    )

    
    

}